import store from "dev/store";
import {Config} from "dev/store/modules/Config.module";

function getRoles() {
	return store.getters.rolesConfig.roles;
}

function findTheRole(roleId) {
	return getRoles().find(role => role.id === roleId);
}

function getTheRule(roleId) {
	let role = findTheRole(roleId);
	return store.getters.rolesConfig.rules[role.rule];
}

function updateConfig(user) {
	let role = getTheRule(user.role);
	if (role.route) {
		Config("routes.default", role.route);
	}
	if (role.baseUrl) {
		Config("request.baseUrl", role.baseUrl);
	}
}

store.watch((state) => state.AuthModule.user, (user) => {
	updateConfig(user);
});

export default {
	get roles() {
		return getRoles();
	},
	getRoleById(roleId) {
		return this.roles.find(role => role.id == roleId);
	},
	toString(id) {
		return getRoles().find(role => role.id === id).text;
	}

};
